import { Button, Card, CardBody, CardHeader, Divider, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from "@nextui-org/react";
import { PencilSquareIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useMemo } from "react";
import RootAdmin from "../../../../components/layouts/RootAdmin";
import ControlledInput from "../../../../components/elements/ControlledInput";
import ModalAlert from "../../../../components/elements/ModalAlert";
import usePelabuhanBongkar from "../../../../hooks/master-data/usePelabuhanBongkar";
import CustomDataGrid from "../../../../components/elements/CustomDataGrid";

export default function IndexPage() {
    const { 
        isEdit,
        page,
        pageSize,
        setPage,
        setPageSize,
        onClickEdit, 
        onClickDelete,
        onSubmitDelete,
        onCloseForm,
        onSubmitForm, 
        modalForm: { onOpenModalForm, isOpenModalForm, onOpenChangeModalForm },
        modalAlert: { isOpenModalAlert, onOpenChangeModalAlert },
        hookForm: { control, handleSubmit, formState: { isSubmitting, dirtyFields, } },
        dataFetch: {
            data,
            isLoading,
        }, 
    } = usePelabuhanBongkar();

    const columns = useMemo(() =>  [
        { field: 'id_lokasi', headerName: 'ID Lokasi' },
        { field: 'kd_kantor', headerName: 'Kode', },
        { field: 'lokasi', headerName: 'Lokasi', valueGetter: (value, row) => `${row?.nm_lokasi} - ${row?.nm_kantor_pendek}` },
        { field: 'longitude', headerName: 'Longitude', },
        { field: 'latitude', headerName: 'Latitude', },
        {
            field: 'action',
            headerName: 'Aksi',
            renderCell: (params) => (
                <div className="flex items-center gap-1">
                    <Button size='sm' onPress={() => onClickEdit(params.row)} color='warning' isIconOnly><PencilSquareIcon className='size-4'/></Button>
                    <Button size='sm' onPress={() => onClickDelete(params.row.id)} color='danger' isIconOnly><TrashIcon className='size-4'/></Button>
                </div>
            ),
            sortable: false,
            filterable: false
        },
    ], [onClickEdit, onClickDelete]);

    return(
        <RootAdmin>
            <Card className="w-full mt-3" radius="sm">
                <CardHeader>
                    <p className="text-md">Daftar Pelabuhan Bongkar</p>
                </CardHeader>
                <Divider />
                <CardBody className='w-full h-[550px] p-5'>
                    <div className="flex justify-between mb-5">
                        <div className="flex flex-col justify-end">
                            <Button onPress={onOpenModalForm} size="sm" color="primary" startContent={<PlusIcon className="size-4 stroke-2"/>}>Tambah</Button>
                        </div>
                    </div>
                    <CustomDataGrid
                        data={data?.data}
                        rowCount={data?.pagination?.totalRecords || 0}
                        isLoading={isLoading}
                        columns={columns}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        page={page}
                        setPage={setPage}
                        initialState={{
                            columns: {
                                columnVisibilityModel: {
                                    longitude: false,
                                    latitude: false,
                                },
                            },
                        }}
                    />
                </CardBody>
            </Card>

            <ModalAlert isOpen={isOpenModalAlert} onOpenChange={onOpenChangeModalAlert} onSubmit={onSubmitDelete} icon="danger"/>
            <Modal scrollBehavior="inside" size="3xl" isOpen={isOpenModalForm} onOpenChange={onOpenChangeModalForm} onClose={onCloseForm} isDismissable={false} isKeyboardDismissDisabled={false}>
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader>{isEdit ? 'Ubah' : 'Tambah'} Pelabuhan Bongkar</ModalHeader>
                            <ModalBody>
                                <form onSubmit={handleSubmit(onSubmitForm)}>
                                    <div className='grid grid-cols-1 md:grid-cols-2 gap-3 mb-6'>  
                                        <ControlledInput label="ID Lokasi" name="id_lokasi" type="text" isRequired={true} control={control} />
                                        <ControlledInput label="Kode" name="kd_kantor" type="text" isRequired={true} control={control} />
                                        <ControlledInput label="Nama Lokasi" name="nm_lokasi" type="text" isRequired={true} control={control} />
                                        <ControlledInput label="Nama Kantor" name="nm_kantor_pendek" type="text" isRequired={true} control={control} />
                                        <ControlledInput label="Latitude" name="latitude" type="text" isRequired={true} control={control} />
                                        <ControlledInput label="Longitude" name="longitude" type="text" isRequired={true} control={control} />                                   
                                    </div>
                                    <div className='flex items-center gap-1'>
                                        <Button isLoading={isSubmitting} isDisabled={isSubmitting || (isEdit && Object.keys(dirtyFields).length === 0)} type='submit' color='primary'>{isEdit ? 'Simpan' : 'Tambah'}</Button>
                                        <Button isDisabled={isSubmitting} color='danger' variant='faded' onPress={onClose}>Batal</Button>
                                    </div>
                                </form>
                            </ModalBody>
                            <ModalFooter>

                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>
        </RootAdmin>
    )
}